import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { ContainerTurnoRecepcionado } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { logoutApp } from "global/context/action/auth/logoutApp";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import CirculoTildeOk from "_+_Portal/assets/images/generico/CirculoTildeOk";
import CardBlueRecepcion from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueRecepcion/CardBlueRecepcion";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import TurnoSinRecepcion from "_+_Portal/_-_Autocheckin/components/genericos/TurnoSinRecepcion/TurnoSinRecepcion";

const TurnoRecepcionado = () => {
  const { authDispatch, resetGlobalContext } = useContext(GlobalContext);
  const {
    turnosSeleccionadosState,
    turnosRecepcionadosState,
    turnosAutoCheckInState,
    pasoDispatch,
    resetAutoterminalContext,
  } = useContext(AutocheckContext);
  const { resetPortalContext, modalDispatch } = useContext(PortalContext);

  const [loading, setLoading] = useState(false);
  const turno = turnosSeleccionadosState.turnosSeleccionados?.data?.[0];
  const history = useHistory();

  const config = getLocalStorage("config", {});
  let opcResetContext = config?.opcResetContext;
  let opcAutoCheckInLabo = config?.opcAutoCheckInLabo;

  // Detección de turnos pendientes sin recepcionar. Usa la misma lógica que
  // TurnosRecepcionadosQR para mantener coherencia: turnos del día que aceptan
  // checkin, no son laboratorio y no están ausentes sin presente.
  const listaTurnosCompleta = (
    turnosAutoCheckInState?.turnosAutoCheckIn?.data ?? []
  ).filter((element) => {
    if (!element?.checkin || element?.idProtocolo) return false;
    if (element?.ausente && !element?.presente) return false;
    return true;
  });
  const listaRecepcionados =
    turnosRecepcionadosState?.turnosRecepcionados?.data ?? [];
  const tienePendientes =
    listaTurnosCompleta.length > listaRecepcionados.length;

  const irARecepcionarPendientes = () => {
    hideModal()(modalDispatch);
    const proximoPaso = opcAutoCheckInLabo ? "SelectorCircuito" : "TurnosDelDia";
    setPaso(proximoPaso)(pasoDispatch);
  };

  const salirSinRecepcionar = () => {
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (!tienePendientes) return;
    showModal(
      <TurnoSinRecepcion
        title={"Turnos sin recepcionar"}
        desc="Cuenta con otros turnos para el día de hoy sin recepcionar."
        textBtnOne={"Salir"}
        textBtnTwo="Recepcionarme"
        handleClick={{
          btnTwoClick: irARecepcionarPendientes,
          btnOneClick: salirSinRecepcionar,
        }}
      />,
    )(modalDispatch);
  }, []);

  const cerrar = () => {
    if (opcResetContext) {
      resetGlobalContext(0);
      resetAutoterminalContext(0);
      history.push("/");
    } else {
      logoutApp(history, resetPortalContext)(authDispatch);
    }
  };
  return (
    <LayoutPasos title={"AUTO CHECK IN"} subtitle={""} type={"no-circle"}>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {loading ? (
        ""
      ) : (
        <ContainerTurnoRecepcionado>
          {/*query ? (
            <SubHeader
              title={"¡Listo"}
              to={"/autoterminalDesktop/turnosConPresente"}
            />
          ) : (
            <span className="title">¡Listo!</span>
          )*/}
          <span className="title">¡Listo!</span>

          <CardBlueRecepcion
            consultorio={turno?.consultorio}
            medico={turno?.medico}
            piso={turno?.piso}
            centro={turno?.centro}
          />
          <CirculoTildeOk width={"145"} height={"145"} animated />

          {tienePendientes && (
            <button
              onClick={irARecepcionarPendientes}
              style={{
                marginBottom: "12px",
                backgroundColor: "var(--color-primary)",
                color: "var(--color-white)",
              }}
            >
              Recepcionar turno pendiente
            </button>
          )}

          <button onClick={cerrar}>Salir</button>
        </ContainerTurnoRecepcionado>
      )}
    </LayoutPasos>
  );
};
export default TurnoRecepcionado;
